



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { vote } from '@/api/api';
import SlideVerify from '@/components/next/SlideVerify.vue';
import { Loading } from 'vant';
import AMapLoader from '@amap/amap-jsapi-loader';
import qs from 'qs';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button)
  .use(Loading);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop({ default: false }) voteWeChat!: boolean;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({ default: -1 }) voteIndex!: number;
  @Prop({ default: 0 }) source!: string;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;

  showSlideVerify = false;
  pointOut = false;
  unionId!: string | null;
  loading: boolean = false;
  showDialog = false;
  dialogTitle = '友情提示';
  dialogContent = '请在上游新闻App进行投票';
  throttleTimer: any = null;
  voteEnable = true;

  pointlng: string = '106.547895';
  pointlat: string = '29.493234';
  AMap: any = null;
  longitude: string = '';
  latitude: string = '';
  distanceM: number = 0;
  addr: string = '';
  AMapLoader: any;

  onLoad() {
    return new Promise(async (resolve, reject) => {
      AMapLoader.load({
        key: '0e409a5781b919c3cf520acb773066c4', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: '1.1', // AMapUI 缺省 1.1
          plugins: [], // 需要加载的 AMapUI ui插件
        },
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: '1.3.2', // Loca 版本，缺省 1.3.2
        },
      })
        .then((AMap: any) => {
          this.AMap = AMap;
          AMap.plugin('AMap.Geolocation', () => {
            const geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, // 是否获取高精度定位，可能影响效率，默认false
              timeout: 10000, // 定位超时时间，ms
              needAddress: true, // 是否需要将定位结果进行逆地理编码操作
              extensions: 'all', // 是否需要详细的你地理编码信息，默认'base'
            });
            // 获取精确位置
            // AMap.event.addListener(geolocation, 'error', this.onError);
            geolocation.getCurrentPosition((status: any, result: any) => {
              this.longitude = result.position ? result.position.lng : '';
              this.latitude = result.position ? result.position.lat : '';
              this.addr = result.formattedAddress;
              // console.log(
              //   '您的经纬度::',
              //   this.longitude,
              //   this.latitude,
              //   '---你的位置：' +
              //     this.addr +
              //     '距离坐标位置：' +
              //     this.pointlng +
              //     '--维度：' +
              //     this.pointlat +
              //     '的距离是：' +
              //     this.distanceM,
              // );
              this.distanceM = this.getDistance(
                this.pointlat,
                this.pointlng,
                this.latitude,
                this.longitude,
              );
              resolve(this.distanceM);
            });
          });
        })
        .catch((e: any) => {
          console.log(e);
        });
    });
  }
  getDistance(lat1: any, lng1: any, lat2: any, lng2: any) {
    let EARTH_RADIUS = 6378.137;
    let radLat1 = this.rad(lat1);
    let radLat2 = this.rad(lat2);
    let a = radLat1 - radLat2;
    let b = this.rad(lng1) - this.rad(lng2);
    let s =
      2 *
      Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
            Math.cos(radLat1) *
              Math.cos(radLat2) *
              Math.pow(Math.sin(b / 2), 2),
        ),
      );
    s = s * EARTH_RADIUS;
    //s = Math.round(s * 10000d) / 10000d;
    s = Math.round(s * 10000) / 10000;
    // s = s * 1000; //乘以1000是换算成米
    return s * 1000;
  }
  rad(d: any) {
    return (d * Math.PI) / 180.0;
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }

  WechatLoginReset() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async onVote() {
    // DONE 大量代码需重构
    // 微信环境中引导用户登录(若需要)
    if (
      this.voteWeChat &&
      isWeiXin() &&
      !window.localStorage.getItem('unionid')
    ) {
      this.WechatLogin();
      return;
    }
    this.onLoad().then((res: any) => {
      if (res > 500) {
        Toast('当前不在地域范围内，无法进行投票！');
      } else {
        // 开始投票，微信环境和App环境传递参数有所不同
        let apiData: any = {};
        if (this.voteWeChat && isWeiXin()) {
          this.unionId = window.localStorage.getItem('unionid');
          apiData = {
            id: this.voteId,
            unionid: this.unionId,
            source: this.source,
          };
        } else {
          return Toast('请在微信客户端投票！');
        }
        // 节流
        if (!this.voteEnable) {
          return Toast('手速不要太快哦');
        }
        this.voteEnable = false;
        clearTimeout(this.throttleTimer);
        this.throttleTimer = setTimeout(() => {
          this.voteEnable = true;
        }, 3000);
        vote(this.voteName, apiData).then((result: any) =>
          this.successVote(result),
        );
      }
    });
  }
  fSlideData(res: any) {
    this.showSlideVerify = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        id: this.voteId,
        unionid: this.unionId,
        source: this.source,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
        source: this.source,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data, this.voteIndex);
        break;
      case 201:
        // 需要滑动验证
        this.showSlideVerify = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          // 需要在App内登录
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          // 老版本唤起App登录页面栈
          window.location.href = 'client:logout';
        }
        break;
      case 203:
        Toast.fail(res.msg);
        break;
      case 505:
        localStorage.removeItem('unionid');
        window.location.reload();
        break;
      case 500:
      case 204:
      case 300:
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
